'use client';

import _defineProperty from "/codebuild/output/src796/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src796/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["classNames", "className", "style", "styles", "unstyled", "vars", "horizontalSpacing", "verticalSpacing", "captionSide", "stripedColor", "highlightOnHoverColor", "striped", "highlightOnHover", "withColumnBorders", "withRowBorders", "withTableBorder", "borderColor", "layout", "variant", "data", "children", "stickyHeader", "stickyHeaderOffset", "mod"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { rem } from '../../core/utils/units-converters/rem.mjs';
import 'react';
import { getSpacing } from '../../core/utils/get-size/get-size.mjs';
import '@mantine/hooks';
import { createVarsResolver } from '../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs';
import 'clsx';
import { getThemeColor } from '../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { useStyles } from '../../core/styles-api/use-styles/use-styles.mjs';
import { Box } from '../../core/Box/Box.mjs';
import { factory } from '../../core/factory/factory.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
import { TableTd, TableTh, TableTr, TableThead, TableTbody, TableTfoot, TableCaption } from './Table.components.mjs';
import { TableProvider } from './Table.context.mjs';
import { TableDataRenderer } from './TableDataRenderer.mjs';
import { TableScrollContainer } from './TableScrollContainer.mjs';
import classes from './Table.module.css.mjs';
var defaultProps = {
  withRowBorders: true,
  verticalSpacing: 7
};
var varsResolver = createVarsResolver(function (theme, _ref) {
  var layout = _ref.layout,
    captionSide = _ref.captionSide,
    horizontalSpacing = _ref.horizontalSpacing,
    verticalSpacing = _ref.verticalSpacing,
    borderColor = _ref.borderColor,
    stripedColor = _ref.stripedColor,
    highlightOnHoverColor = _ref.highlightOnHoverColor,
    striped = _ref.striped,
    highlightOnHover = _ref.highlightOnHover,
    stickyHeaderOffset = _ref.stickyHeaderOffset,
    stickyHeader = _ref.stickyHeader;
  return {
    table: {
      "--table-layout": layout,
      "--table-caption-side": captionSide,
      "--table-horizontal-spacing": getSpacing(horizontalSpacing),
      "--table-vertical-spacing": getSpacing(verticalSpacing),
      "--table-border-color": borderColor ? getThemeColor(borderColor, theme) : void 0,
      "--table-striped-color": striped && stripedColor ? getThemeColor(stripedColor, theme) : void 0,
      "--table-highlight-on-hover-color": highlightOnHover && highlightOnHoverColor ? getThemeColor(highlightOnHoverColor, theme) : void 0,
      "--table-sticky-header-offset": stickyHeader ? rem(stickyHeaderOffset) : void 0
    }
  };
});
var Table = factory(function (_props, ref) {
  var props = useProps("Table", defaultProps, _props);
  var classNames = props.classNames,
    className = props.className,
    style = props.style,
    styles = props.styles,
    unstyled = props.unstyled,
    vars = props.vars,
    horizontalSpacing = props.horizontalSpacing,
    verticalSpacing = props.verticalSpacing,
    captionSide = props.captionSide,
    stripedColor = props.stripedColor,
    highlightOnHoverColor = props.highlightOnHoverColor,
    striped = props.striped,
    highlightOnHover = props.highlightOnHover,
    withColumnBorders = props.withColumnBorders,
    withRowBorders = props.withRowBorders,
    withTableBorder = props.withTableBorder,
    borderColor = props.borderColor,
    layout = props.layout,
    variant = props.variant,
    data = props.data,
    children = props.children,
    stickyHeader = props.stickyHeader,
    stickyHeaderOffset = props.stickyHeaderOffset,
    mod = props.mod,
    others = _objectWithoutProperties(props, _excluded);
  var getStyles = useStyles({
    name: "Table",
    props: props,
    className: className,
    style: style,
    classes: classes,
    classNames: classNames,
    styles: styles,
    unstyled: unstyled,
    rootSelector: "table",
    vars: vars,
    varsResolver: varsResolver
  });
  return /* @__PURE__ */jsx(TableProvider, {
    value: {
      getStyles: getStyles,
      stickyHeader: stickyHeader,
      striped: striped === true ? "odd" : striped || void 0,
      highlightOnHover: highlightOnHover,
      withColumnBorders: withColumnBorders,
      withRowBorders: withRowBorders,
      captionSide: captionSide || "bottom"
    },
    children: /* @__PURE__ */jsx(Box, _objectSpread(_objectSpread(_objectSpread({
      component: "table",
      variant: variant,
      ref: ref,
      mod: [{
        "data-with-table-border": withTableBorder
      }, mod]
    }, getStyles("table")), others), {}, {
      children: children || !!data && /* @__PURE__ */jsx(TableDataRenderer, {
        data: data
      })
    }))
  });
});
Table.classes = classes;
Table.displayName = "@mantine/core/Table";
Table.Td = TableTd;
Table.Th = TableTh;
Table.Tr = TableTr;
Table.Thead = TableThead;
Table.Tbody = TableTbody;
Table.Tfoot = TableTfoot;
Table.Caption = TableCaption;
Table.ScrollContainer = TableScrollContainer;
Table.DataRenderer = TableDataRenderer;
export { Table };